/** Per-partner image framing for the Trusted By accordion. */

export type BrandImageLayout = {
  left: string;
  top: string;
  width: string;
  height: string;
  objectPosition?: string;
};

export type BrandImageStrategy = {
  objectPosition: string;
};

const EXPANDED_POSITION_BY_ID: Record<string, string> = {
  hoarders: '50% 24%',
};

/** Figma handoff — desktop collapsed card image crops (node 266:2311–266:2315). */
const COLLAPSED_LAYOUT_BY_ID: Record<string, BrandImageLayout> = {
  honest: {
    left: '-90.97%',
    top: '0',
    width: '190.91%',
    height: '100%',
  },
  peacock: {
    left: '-116.38%',
    top: '0',
    width: '216.12%',
    height: '100%',
  },
  rachael: {
    left: '-115.74%',
    top: '0',
    width: '216.12%',
    height: '100%',
  },
  hoarders: {
    left: '-58.06%',
    top: '0',
    width: '216.12%',
    height: '100%',
  },
};

const DEFAULT_COLLAPSED_LAYOUT: BrandImageLayout = {
  left: '0',
  top: '0',
  width: '100%',
  height: '100%',
  objectPosition: 'center',
};

/** Figma handoff — mobile collapsed card image crops (node 272:2920–272:2923). */
const MOBILE_COLLAPSED_LAYOUT_BY_ID: Record<string, BrandImageLayout> = {
  honest: {
    left: '0',
    top: '-49.71%',
    width: '100%',
    height: '388.35%',
  },
  peacock: {
    left: '0',
    top: '-49.82%',
    width: '100%',
    height: '388.35%',
  },
  rachael: {
    left: '0',
    top: '-49.66%',
    width: '100%',
    height: '388.35%',
  },
  hoarders: {
    left: '0',
    top: '-49.77%',
    width: '100%',
    height: '388.35%',
  },
};

const DEFAULT_MOBILE_COLLAPSED_LAYOUT: BrandImageLayout = {
  left: '0',
  top: '-49.71%',
  width: '100%',
  height: '388.35%',
};

export const DESKTOP_BRAND_CARD_HEIGHT = 364;

export const DESKTOP_BRAND_CARD_WIDTH = {
  expanded: 420,
  firstCollapsed: 220,
} as const;

export const MOBILE_BRAND_CARD_HEIGHT = {
  expanded: 282,
  collapsed: 79,
} as const;

export const getExpandedBrandImageStrategy = (
  partnerId: string,
): BrandImageStrategy => ({
  objectPosition: EXPANDED_POSITION_BY_ID[partnerId] ?? 'center',
});

export const getCollapsedBrandImageLayout = (
  partnerId: string,
): BrandImageLayout =>
  COLLAPSED_LAYOUT_BY_ID[partnerId] ?? DEFAULT_COLLAPSED_LAYOUT;

export const getMobileCollapsedBrandImageLayout = (
  partnerId: string,
): BrandImageLayout =>
  MOBILE_COLLAPSED_LAYOUT_BY_ID[partnerId] ?? DEFAULT_MOBILE_COLLAPSED_LAYOUT;
